import Vue from 'vue'
import { Toast } from 'vant';
import { Alert } from 'element-ui';
Vue.use(Toast);
import router from '@/main/router/index';
var dsBridge = require("dsbridge");
import Cookies from 'js-cookie'

export default {
    state: {
        examineStatus: [{
            code: 1,
            name: '营业执照'
        },
        {
            code: 2,
            name: '税务登记证'
        },
        {
            code: 3,
            name: '组织机构代码证'
        },
        {
            code: 4,
            name: '开户许可证-同名基本户证明'
        },
        {
            code: 5,
            name: '数字证书使用承诺函'
        },
        {
            code: 6,
            name: '法人身份证'
        },
        {
            code: 7,
            name: '经办人身份证'
        },
        {
            code: 24,
            name: '非法人企业授权书'
        },
        {
            code: 25,
            name: '企业名称'
        },
        {
            code: 35,
            name: '法定代表人授权书'
        },
        {
            code: 38,
            name: '云信-跨平台互认授权'
        },
        {
            code: 39,
            name: '云租-跨平台互认授权书'
        },
        {
            code: 40,
            name: '云保-跨平台互认授权书'
        },
        {
            code: 54,
            name: '跨平台-云信-法定代表人授权书'
        },
        {
            code: 71,
            name: '跨平台-云保-法定代表人授权书'
        }
        ],
        clientType:"",
        factorIngStatusList:[{
            code: 0,
            name: '未到期',
        }],
        //商机类型
        businessTypeSatus:[{
            name:'全部',
            code:0
        },{
            name:'添加产品',
            code:1
        },{
            name:'添加需求',
            code:2
        }],
    },
    mutations: {
        setToken(state, token) {
            state.token = token;
            Vue.localStrage.set('token', token);
        },
        setXsrfToken(state, token) {
            state.xsrfToken = token;
            Vue.localStrage.set('xsrfToken', token);
        },
        setClientType(state, data) {
            state.clientType = data;
        }
    },
    getters: {
        getToken: state => {
            return state.token || sessionStorage.getItem("zqyl-token") || localStorage.getItem("token");
        },
        getXsrfToken: state => {
            return state.xsrfToken || Vue.localStrage.get("xsrfToken");
        },
        getUserInfo: state => {
            return JSON.stringify(state.userInfo) != "{}" ? state.userInfo : JSON.parse(Vue.localStrage.get("userInfo"));
        },
        getExamineStatus: state => (code, obj) => {
            let data = state[obj].find(item => item.code == code);
            return data ? data.name : "";
        },
        getClientType: state => {
            return state.clientType;
        }
    },
    actions: {
        // 第三方获取用户信息
        async getUserInfo(store) {
            let userInfo = null;
            // console.log(router.app._route.query.from=="electron")
            if(router.app._route.query.from=="electron"){
                let res = await window.YLBridgeAPI.getUserInfo()
                userInfo = JSON.parse(res);
            }else{
                window.dsBridge = dsBridge;
                if(dsBridge.hasNativeMethod('getUserInfo')){
                    userInfo = dsBridge.call("getUserInfo");
                    userInfo = JSON.parse(userInfo); 
                }
            }
            if(!userInfo) return;
            store.commit("setToken", userInfo.token);
            localStorage.setItem("userId", userInfo.userId);   //用户id
            localStorage.setItem("userName", userInfo.userName);
            localStorage.setItem("selectCompanyId", userInfo.companyId);
            store.commit("setClientType", userInfo.clientType);

            Cookies.set('Authorization', userInfo.token);

            // window.dsBridge = dsBridge;
            // if (dsBridge.hasNativeMethod('getUserInfo')) {
            //     let userInfo = dsBridge.call("getUserInfo");
            //     userInfo = JSON.parse(userInfo);
            //     store.commit("setToken", userInfo.token);
            //     localStorage.setItem("userId", userInfo.userId);   //用户id
            //     localStorage.setItem("userName", userInfo.userName);
            //     localStorage.setItem("selectCompanyId", userInfo.companyId);
            //     store.commit("setClientType", userInfo.clientType);

            //     Cookies.set('Authorization', userInfo.token);
            // } else {
            //     // store.commit("setToken", router.currentRoute.query.token);
            //     // localStorage.setItem("userId", router.currentRoute.query.userId);   //用户id
            //     // localStorage.setItem("userName", router.currentRoute.query.userName);
            //     // localStorage.setItem("selectCompanyId", router.currentRoute.query.companyId);
            //     // store.commit("setClientType", router.currentRoute.query.clientType);
            // }
        },
        // token失效chuli 
        tokenFailure(store, res) {
            let { data, pending } = res;
            pending.forEach(v => {
                v.f();
            });
            pending = [];
            Toast(data.msg);
            store.commit('setToken', "");
            store.commit('setXsrfToken', "");
            localStorage.clear();
            sessionStorage.clear();
            store.dispatch("goLogin");
            router.push({
                name: 'Login',
            });
        },
    }
}